/**
 * Created by hp on 2017/8/4.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

var hasOwn = {}.hasOwnProperty;
function classNames () {
    var classes = [];

    for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
            classes.push(arg);
        } else if (Array.isArray(arg)) {
            classes.push(classNames.apply(null, arg));
        } else if (argType === 'object') {
            for (var key in arg) {
                if (hasOwn.call(arg, key) && arg[key]) {
                    classes.push(key);
                }
            }
        }
    }

    return classes.join(' ');
}

// icon
const deprecateValue = {
    'safe_success': 'safe-success',
    'safe_warn': 'safe-warn',
    'success_circle': 'success-circle',
    'success_no_circle': 'success-no-circle',
    'waiting_circle': 'waiting-circle',
    'info_circle': 'info-circle'
};

/**
 * WeUI Icons
 *
 */
class Icon extends React.Component {
    static propTypes = {
        /**
         * types of [weui icons](https://github.com/weui/weui/wiki/Icon)
         *
         */
        value: PropTypes.string,
        /**
         * size of icon, options: small/large
         *
         */
        size: PropTypes.string
    };

    static defaultProps = {
        value: 'success',
        size: 'small'
    };

    render() {
        const {value, size, className, primary, ...others} = this.props;

        if (Object.keys(deprecateValue).indexOf(value) !== -1){
            deprecationWarning(`Icon ${value}`, `Icon ${deprecateValue[value]}`);
        }

        const cls = classNames({
            ['weui-icon-' + value]: value !== 'loading',
            'weui-icon_msg': size === 'large' && !primary,
            'weui-icon_msg-primary': size === 'large' && primary,
            'weui-loading': value === 'loading',
            [className]: className
        });

        return (
            <i {...others} className={cls}/>
        );
    }
}


/**
 *  weui search component
 *
 */
class SearchBar extends React.Component {
    static propTypes = {
        /**
         * default value for the searchbar if any
         *
         */
        defaultValue: PropTypes.string,
        /**
         * default place holder text
         *
         */
        placeholder: PropTypes.string,
        /**
         * name of the input component
         *
         */
        searchName: PropTypes.string,
        /**
         * trigger when text change on input pass `text` property
         *
         */
        onChange: PropTypes.func,
        /**
         * trigger when user click clear icon
         *
         */
        onClear: PropTypes.func,
        /**
         * trigger when user click cancel button
         *
         */
        onCancel: PropTypes.func,
        /**
         * trigger when user submit (enter action)
         *
         */
        onSubmit: PropTypes.func,
        /**
         * language object consists of `cancel` property
         *
         */
        lang: PropTypes.object
    };

    static defaultProps = {
        placeholder: '搜索',
        searchName: 'q',
        onChange: undefined,
        onClear: undefined,
        onCancel: undefined,
        onSubmit: undefined,
        lang: { cancel: '取消' },
        autocomplete: 'off'
    };

    constructor(props){
        super(props);

        this.state = {
            focus: this.props.defaultValue ? true : false,
            clearing: false,
            text: this.props.defaultValue ? this.props.defaultValue : ''
        };

        if (this.props.defaultValue !== ''){
            if (this.props.onChange) this.props.onChange(this.state.text);
        }
    }

    componentWillReceiveProps (props) {
        this.setState({ text: props.defaultValue })
    }

    changeHandle(e) {
        let text = e.target.value;
        if (this.props.onChange) this.props.onChange(text, e);
        this.setState({text});
    }

    cancelHandle(e) {
        this.setState({
            focus: false,
            text: ''
        });
        // this.props.onChange('', e);
        // this.props.onCancel(e);
        if (this.props.onCancel) this.props.onCancel(e);
        if (this.props.onChange) this.props.onChange('', e);
    }

    clearHandle(e) {
        e.preventDefault();
        e.stopPropagation();

        this.setState({text: '', clearing: true});
        if (this.props.onClear) this.props.onClear(e);
        // In most cases, you can attach a ref to the DOM node and avoid using findDOMNode at all.
        // When render returns null or false, findDOMNode returns null.
        // 这里是截取官网的说明，在ref回调函数内确实会返回null，尤其是配合redux使用的时候，这个时候需要对其进行null判断
        this.refs.searchInput.focus();
        // ReactDOM.findDOMNode(this.refs.searchInput).focus()
        if (this.props.onChange) this.props.onChange('', e);
    }

    blurHandle(e) {
        if (this.state.text === ''){
            this.blurSettime = setTimeout(() => {
                this.setState({ focus: false});
            }, 500)
        }
    }

    submitHandle(e) {
        if (this.props.onSubmit) {
            e.preventDefault();
            e.stopPropagation();
            this.props.onSubmit(this.state.text, e);
        }
    }

    render() {
        const {children, defaultValue, autocomplete, placeholder, className, searchName} = this.props;
        const clz = classNames({
            'weui-search-bar': true,
            'weui-search-bar_focusing': this.state.focus
        }, className);

        return (
            <div className={clz}>
                <form className='weui-search-bar__form' onSubmit={this.submitHandle.bind(this)}>
                    <div className='weui-search-bar__box'>
                        <Icon value='search'/>
                        <input
                            ref='searchInput'
                            type='search'
                            name={searchName}
                            className='weui-search-bar__input'
                            placeholder={placeholder}
                            onFocus={e=>this.setState({focus: true})}
                            onBlur={this.blurHandle.bind(this)}
                            onChange={this.changeHandle.bind(this)}
                            value={this.state.text}
                            autoComplete={autocomplete}
                        />
                        {/*React will not trigger onMouseDown when not onClick presented*/}
                        <a
                            className='weui-icon-clear'
                            onClick={this.clearHandle.bind(this)}
                        />
                    </div>
                    <label
                        className='weui-search-bar__label'
                        onClick={()=>{
                            let searchInput = this.refs.searchInput;
                            if (searchInput) {
                                searchInput.focus();
                            }
                        }}
                        style={{display: this.state.text ? 'none' : null}}
                    >
                        <Icon value='search'/>
                        <span>{placeholder}</span>
                    </label>
                </form>
                <a className='weui-search-bar__cancel-btn' onClick={this.cancelHandle.bind(this)}>{this.props.lang.cancel}</a>
            </div>
        );
    }
}

class WKSearch extends Component {

    static defaultProps = {
        defaultValue: '',
        placeholder: '搜索',
        onChange: null,
        onSubmit: null,
        lang: {cancel: '取消'},
        onClear: null,
        onCancel: null
    };


    render() {

        const {defaultValue, placeholder, onChange, onSubmit, lang, onClear, onCancel} = this.props;

        return (
            <SearchBar onClear={onClear} onCancel={onCancel} onChange={onChange} onSubmit={onSubmit} lang={lang} placeholder={placeholder}
                       defaultValue={defaultValue}/>
        )
    }
}

export default WKSearch



// WEBPACK FOOTER //
// ./src/components/wk/WKSearch.js